import { render, staticRenderFns } from "./HelpFinance.vue?vue&type=template&id=fdd1d360&"
import script from "./HelpFinance.vue?vue&type=script&lang=js&"
export * from "./HelpFinance.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports